import { app } from "../../config/constants"
import * as TopicsActions from './actions'
import {store} from "../../reducers";
import * as CampaignsSettingsActions from "../settings/campaigns/actions";

export const write = ( topic ) => {
	return new Promise( ( resolve, reject ) => {
		app.database().ref('/cams/topics').orderByChild('wordpressId').equalTo(topic.wordpressId).once('value', (topics) => {
			if (null === topics.val()) {
				app.database().ref('/cams/topics').push(topic).then(topicSnap => {
					resolve();
				});
			} else {
				topics.forEach((topicSnap) => {
					resolve();
					app.database().ref('/cams/topics').child(topicSnap.key).set(topic).then(topicSnap => {
						resolve();
					});
				});
			}
		});
	} );
};

export const getTopics = () => {
	new Promise( ( resolve, reject ) => {
		let topicsToReturn = [];
		app.database().ref('/cams/topics').orderByChild('name').once('value', ( topics ) => {
			let j = 0;
			topics.forEach( ( topic ) => {
				topicsToReturn.push({
					name: topic.val().name,
					key: topic.key,
				});

				if ( ++j === topics.numChildren() ) {
					resolve( topicsToReturn );
				}



			});
		});
	}).then( ( topics ) => {
		store.dispatch(TopicsActions.AddTopics(topics));
	})
};

export const resetTopics = () => {
	store.dispatch(TopicsActions.ResetTopics());

	return Promise.resolve();
};


// WEBPACK FOOTER //
// ./src/api/topics/index.js